import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init } from './modules'
import Loading from 'components/Loading'
import { languageChange } from 'store/siteConfig'

export default function(route) {
  const Select = Loadable({
    loader: () => import('./Select'),
    render(loaded, props) {
      const Component = connect((state) => ({
        utilityParkingSelectState: state.utilityParkingSelectState,
        siteConfig: state.siteConfig
      }), {
        init,
        languageChange
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/select`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Select {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
